import React, { Component } from "react";

class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <li>
                            <a href="https://play.google.com/store/apps/details?id=com.silibrain.botikir&hl=es"><img src="/assets/images/brand/brand-01.png" alt="Google Play Store"/></a>
                    </li>
                    <li>
                            <a href="https://apps.apple.com/us/app/botikir/id1594702225"><img src="/assets/images/brand/brand-02.png" alt="iOS App Store"/></a>
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;